// components/admin/content-management/add-section.component.jsx

import { useContext, useState } from 'react';

import { ToastContext } from '../../../../contexts/toast.context';
import Button from '../../../reusable/button/button.component';
import Spinner from '../../../reusable/spinner/spinner.component';

import Client from '../../../../tools/client';
import sectionComponentMap from './index.js';

import {
  ContentContainer,
  Input,
  Label,
  MainContainer,
  Option,
  Select,
  Title
} from '../../../../styles/component.styles';

const client = new Client();

const AddSection = ({ page, getPage }) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [sectionFormData, setSectionFormData] = useState(null);

  const { errorToast, successToast } = useContext(ToastContext);

  const handleTypeChange = (newType) => {
    setType(newType);
    setSectionFormData(null); // reset form data when switching types
  };

  const SectionConfig = sectionComponentMap[type];
  const SectionComponent = SectionConfig?.component || null;

  const checkFields = () => {
    if (!type) return { result: false, error: 'Please select a section type' };
    if (!sectionFormData || !sectionFormData.metadata) return { result: false, error: 'Missing section data' };
    return { result: true };
  };

  const submit = async () => {
    const checkInputs = checkFields();
    if (!checkInputs.result) return errorToast(checkInputs.error);

    setLoading(true);
    const formData = new FormData();

    formData.append('pageId', page.id);
    formData.append('title', title);
    formData.append('type', type);
    formData.append('position', page.Sections.length + 1);
    formData.append('content', JSON.stringify(sectionFormData.content));
    formData.append('metadata', JSON.stringify(sectionFormData.metadata));

    sectionFormData.files?.forEach((fileData, index) => {
      formData.append('files', fileData.file);
      formData.append(`image_metadata_${index}_type`, fileData.type);
      if (fileData.position !== undefined) {
        formData.append(`image_metadata_${index}_position`, fileData.position);
      }
    });

    try {
      await client.createSection(formData);
      await getPage();
      successToast('Section added successfully');
      // Reset form fields
      setTitle('');
      setType('');
      setSectionFormData(null);
    } catch (err) {
      errorToast('There was an error adding the section');
    }

    setLoading(false);
  };

  return (
    <MainContainer>
      {loading ? <Spinner /> : (
        <ContentContainer>
          <Title>Add New Section</Title>

          <Label htmlFor="section-title">Section Title (Optional) - Use this to label the section for internal purposes or for future use in single-page app navigation.</Label>
          <Input
            id="section-title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Section Title"
          />

          <Select value={type} onChange={(e) => handleTypeChange(e.target.value)}>
            <Option value="" disabled> -- select type -- </Option>
            {Object.entries(sectionComponentMap).map(([key, config]) => (
              <Option key={key} value={key}>{config.name}</Option>
            ))}
          </Select>

          {SectionComponent && (
            <SectionComponent onChange={(data) => setSectionFormData(data)} />
          )}

          <Button onClick={submit}>Submit</Button>
        </ContentContainer>
      )}
    </MainContainer>
  );
};

export default AddSection;